export const UPDATE_DEVICE_COUNTS = 'UPDATE_DEVICE_COUNTS'
export const UPDATE_DEVICE_COUNTS_SUCCESS = 'UPDATE_DEVICE_COUNTS_SUCCESS'
export const UPDATE_DEVICE_COUNTS_FAILURE = 'UPDATE_DEVICE_COUNTS_FAILURE'
